import { render, staticRenderFns } from "./joining-form-render.vue?vue&type=template&id=60842dbb&scoped=true"
import script from "./joining-form-render.vue?vue&type=script&lang=js"
export * from "./joining-form-render.vue?vue&type=script&lang=js"
import style0 from "./joining-form-render.vue?vue&type=style&index=0&id=60842dbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60842dbb",
  null
  
)

export default component.exports